<template>
  <dialog-base>
    <div ref="page"
         class="mod-flower">
      <canvas ref="canvas"
              class="paint"></canvas>
      <div class="title">
        恭喜你
      </div>
      <div class="content">
        完成寻宝任务
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
import ConfettiPaint from '@/utils/ConfettiPaint'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$refs.page.classList.add('bounceIn')
    new ConfettiPaint(this.$refs.canvas)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.mod-flower {
  position: relative;
  width: 100%;
  .paint {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -300px;
    width: 100%;
    height: 400px;
    z-index: -1;
  }
  .title {
    font-size: 48px;
    text-align: center;
    font-weight: bolder;
    letter-spacing: 10px;
    color: #ffffff;
    text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
      #872c0c 0 -2px 2px;
  }
  .content {
    margin-top: 80px;
    font-size: 38px;
    text-align: center;
    letter-spacing: 16px;
    color: #ffffff;
    text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
      #872c0c 0 -2px 2px;
  }
}
$anime: 0.2s ease-in;
@keyframes bounceIn {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.bounceIn {
  animation: bounceIn $anime;
  transform: scale(1);
}
</style>